var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};



















































pug_mixins["label-with-help"] = pug_interp = function(text, topic){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"label-with-help\" layout=\"row\"\u003E\u003Clabel\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003Chelp-mate" + (pug.attr("topic", topic, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};



















pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_mixins["info-dialog"] = pug_interp = function(name, header, icon){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["information",name], [false,true]), false, true)+pug.attr("ng-switch-when", name, true, true)+" layout=\"column\" layout-align=\"center center\"") + "\u003E\u003Cdiv\u003E\u003Cmd-icon class=\"warning\"\u003E" + (pug.escape(null == (pug_interp = icon) ? "" : pug_interp)) + "\u003C\u002Fmd-icon\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = header) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E";
if (block) {
block && block();
}
pug_html = pug_html + "\u003Cdiv class=\"actions\" layout=\"column\" layout-align=\"center center\" layout-padding\u003E\u003Cmd-button class=\"md-raised md-primary\" id=\"ok-button\" ng-click=\"vm.closeBidContainer()\"\u003EOK \u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"switch\" ng-switch=\"vm.currentScreen\"\u003E\u003Cdiv class=\"enter-bid\" ng-switch-when=\"enter-bid\" layout=\"column\" layout-padding\u003E\u003Ch2\u003EBidding range\u003Cdiv\u003E{{vm.bidder.investorMinRate | asNumber:1}}&thinsp;-{{vm.bidder.investorMaxRate | asNumber:1}} \u003Csup\u003E%\u003C\u002Fsup\u003E p.a.\u003C\u002Fdiv\u003E\u003C\u002Fh2\u003E\u003Cform name=\"vm.bidForm\" layout=\"column\" layout-align=\"space-around\" flex\u003E\u003Cdiv class=\"bid-amount\" layout=\"column\"\u003E\u003Clabel\u003EBid amount\u003C\u002Flabel\u003E\u003Cmd-input-container\u003E\u003Cdiv class=\"bid-input\" layout=\"row\"\u003E\u003Cstep-ball id=\"amount-down\" ng-model=\"vm.bidder.amount\" step=\"vm.bidder.bidStep\" direction=\"down\" min=\"vm.bidder.minimumBid\"\u003E\u003C\u002Fstep-ball\u003E\u003Cspan class=\"value-display selected-amount\" aria-label=\"amount\" ng-cloak flex\u003E{{vm.bidder.amount | asCurrency:0}}\u003C\u002Fspan\u003E\u003Cstep-ball id=\"amount-up\" ng-model=\"vm.bidder.amount\" step=\"vm.bidder.bidStep\" direction=\"up\" max=\"vm.bidder.maximumBid\"\u003E\u003C\u002Fstep-ball\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"message-override\"\u003EAvailable Funds: &thinsp;\u003Cspan class=\"message-highlight available-funds\"\u003E{{vm.investor.availableFunds | asCurrency:0}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-input-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bid-min-rate\" layout=\"column\"\u003E";
pug_mixins["label-with-help"]("Minimum investor rate", "minimum-investor-rate");
pug_html = pug_html + "\u003Cmd-input-container\u003E\u003Cdiv class=\"bid-input\" layout=\"row\"\u003E\u003Cstep-ball id=\"borrower-min-rate-down\" ng-model=\"vm.bidder.borrowerMinRate\" step=\"vm.bidder.rateStep\" direction=\"down\" min=\"vm.bidder.minRate\"\u003E\u003C\u002Fstep-ball\u003E\u003Cspan class=\"value-display investor-min-rate\" aria-label=\"investor-min-rate\" ng-cloak flex\u003E{{vm.bidder.investorMinRate | asPercentage:1}} p.a.\u003C\u002Fspan\u003E\u003Cstep-ball id=\"borrower-min-rate-up\" ng-model=\"vm.bidder.borrowerMinRate\" step=\"vm.bidder.rateStep\" direction=\"up\" max=\"vm.bidder.maxRate\"\u003E\u003C\u002Fstep-ball\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-input-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-button class=\"md-raised md-warn cancel-bid-button\" ng-click=\"vm.closeBidContainer()\"\u003ECancel bid\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised md-primary place-bid-button\" ng-disabled=\"vm.bidForm.$invalid\" ng-click=\"vm.gotoConfirmBidScreen()\"\u003ESubmit bid\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"confirm-bid\" ng-switch-when=\"confirm-bid\" layout=\"column\" layout-padding\u003E\u003Cdiv class=\"confirm-bid-container\" layout=\"column\" layout-align=\"center center\" layout-padding\u003E\u003Cdiv class=\"bidding-message\"\u003EPlease confirm your bid of\u003C\u002Fdiv\u003E\u003Ch2 class=\"bidding-details bid-amount\"\u003E{{vm.bidder.amount | asCurrency:0:'up'}}\u003C\u002Fh2\u003E\u003Cdiv class=\"bidding-message\"\u003Eat a minimum investor rate of\u003C\u002Fdiv\u003E\u003Ch2 class=\"bidding-details bid-rate\"\u003E{{vm.bidder.investorMinRate | asPercentage:1}}\u003C\u002Fh2\u003E\u003Cdiv class=\"actions\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-button class=\"md-raised md-warn cancel-bid-button\" ng-if=\"vm.status === 'pre-confirmation'\" ng-click=\"vm.closeBidContainer()\"\u003ECancel bid\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised md-primary confirm-bid-button\" ng-if=\"vm.status === 'pre-confirmation'\" ng-click=\"vm.confirm()\"\u003EConfirm bid\u003C\u002Fmd-button\u003E\u003Cmd-progress-circular class=\"md-primary\" ng-if=\"vm.status === 'bid-in-progress'\" md-mode=\"indeterminate\" md-size=\"40\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"result\" ng-switch-when=\"bid-result\"\u003E\u003Cdiv class=\"container\" ng-switch=\"vm.resultCode\"\u003E";
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.createdBid.amount | asCurrency:0}} was accepted \u003Cbr\u003E \u003Cbr\u003E Minimum investor rate {{vm.createdBid.minRate * 1.0 - vm.auction.investorMarginRate * 1.0 | asPercentage:1}}\u003C\u002Fp\u003E";
}
}, 'success-total', 'Bid accepted');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003E Only {{vm.createdBid.activeAmount | asCurrency:0}} of your {{vm.createdBid.amount | asCurrency:0}} bid was accepted \u003Cbr\u003E \u003Cbr\u003E Minimum investor rate {{vm.createdBid.minRate * 1.0 - vm.auction.investorMarginRate * 1.0 | asPercentage:1}}\u003C\u002Fp\u003E";
}
}, 'success-partial', 'Bid partially accepted');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.bidder.amount| asCurrency:0}} at minimum investor rate of {{vm.bidder.investorMinRate | asPercentage:1}} was outbid\u003C\u002Fp\u003E";
}
}, 'error-outbid', "You've been outbid!");
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.bidder.amount | asCurrency:0}} at minimum investor rate of {{vm.bidder.investorMinRate | asPercentage:1}} failed because the auction is now complete\u003C\u002Fp\u003E";
}
}, 'error-auction-finished', 'Bid rejected', 'warning');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.bidder.amount | asCurrency:0}} at minimum investor rate of {{vm.bidder.investorMinRate | asPercentage:1}} failed because the auction has not started\u003C\u002Fp\u003E";
}
}, 'error-auction-not-started', 'Bid rejected', 'warning');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.bidder.amount| asCurrency:0}} is not within acceptable range\u003C\u002Fp\u003E";
}
}, 'error-amount-range', 'Bid rejected', 'warning');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid rate {{vm.bidder.investorMinRate | asPercentage:1}} is not within acceptable range\u003C\u002Fp\u003E";
}
}, 'error-rate-range', 'Bid rejected', 'warning');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.bidder.amount | asCurrency:0}} at minimum investor rate of {{vm.bidder.investorMinRate | asPercentage:1}} failed because you have insufficient funds\u003C\u002Fp\u003E";
}
}, 'error-insufficient-funds', 'Bid rejected', 'warning');
pug_mixins["info-dialog"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EYour bid of {{vm.bidder.amount | asCurrency:0}} at minimum investor rate of {{vm.bidder.investorMinRate | asPercentage:1}} failed for technical reasons\u003C\u002Fp\u003E";
}
}, 'error-unknown', 'Bid failed', 'error');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;